import React from 'react';
const bonuses = [{
  num: '01',
  label: '🎁 BONO 1',
  title: 'Kit Express PRO: Sesión Perfecta en 10 Min',
  desc: '6 plantillas de sesión copy/paste con objetivos, evidencia y cierre. Elegís, seguís, ejecutás.',
  price: '$12.000'
}, {
  num: '02',
  label: '🎁 BONO 2',
  title: 'Scripts PRO para Familias',
  desc: '80 mensajes de WhatsApp listos para adherencia, objeciones y seguimiento semanal.',
  price: '$9.000'
}, {
  num: '03',
  label: '🎁 BONO 3',
  title: 'Evolución & Reportes 360',
  desc: 'Trackers mensuales + informe para familia + informe para equipo + alta. Todo en 1 página.',
  price: '$10.000'
}, {
  num: '04',
  label: '🎁 BONO 4',
  title: 'Actividades SOS de Consultorio',
  desc: '24 fichas listas con objetivo, pasos, evidencia y cierre. Para los días sin tiempo de preparar.',
  price: '$9.000'
}, {
  num: '05',
  label: '🎁 BONO 5',
  title: 'Consultorio 360: Setup PRO',
  desc: 'Plano por zonas + checklists + lista low-cost Argentina + rotación semanal de materiales.',
  price: '$8.000'
}, {
  num: '06',
  label: '🎁 BONO 6',
  title: 'Situaciones Difíciles en Sesión',
  desc: '25 casos reales resueltos en 3 pasos: qué hacer, qué decir y qué mandar a casa.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-41">
      <div className="mx-auto max-w-4xl" data-id="element-42">
        {/* Heading */}
        <div className="mb-6 text-center" data-id="element-43">
          <h2 className="text-3xl font-black leading-10 text-gray-900 m-0 mb-2" data-id="element-44">
            Más los{' '}
            <span className="text-cyan-brand" data-id="element-45">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-sm text-gray-500 m-0" data-id="element-46">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* Bonus Cards Grid */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-47">
          {bonuses.map(bonus => <div key={bonus.num} className="flex flex-col rounded-xl p-4 shadow-sm" style={{
          backgroundColor: 'rgb(240, 249, 255)',
          border: '1px solid rgb(0, 180, 216)'
        }} data-id="element-48">
              <div className="mb-1 text-2xl leading-8 font-black text-cyan-brand" data-id="element-49">
                {bonus.num}
              </div>
              <div className="mb-1 text-[10px] font-bold uppercase tracking-[1.2px] text-cyan-brand" data-id="element-50">
                {bonus.label}
              </div>
              <h3 className="text-sm font-black text-gray-900 m-0 mb-1" data-id="element-51">
                {bonus.title}
              </h3>
              <p className="flex-1 text-xs text-gray-600 m-0 mb-3" data-id="element-52">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-xs text-gray-500 line-through" data-id="element-54">
                  {bonus.price}
                </span>
                <span className="bg-cyan-brand text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value Footer */}
        <div className="mx-auto max-w-2xl text-center rounded-xl p-4 shadow-sm" style={{
        backgroundColor: 'rgb(240, 249, 255)',
        border: '1px solid rgba(0, 180, 216, 0.4)'
      }} data-id="element-56">
          <p className="text-xs font-semibold uppercase tracking-[1.4px] text-cyan-brand m-0 mb-1" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="mb-1 flex flex-col sm:flex-row items-center justify-center gap-2" data-id="element-58">
            <span className="text-base text-gray-500 line-through" data-id="element-59">
              $58.000
            </span>
            <span className="text-base sm:text-xl font-black tracking-wide text-cyan-brand" data-id="element-60">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
          <p className="text-xs text-gray-500 m-0" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}